import { Children, cloneElement, useContext, useEffect } from 'react';

import { useAgenciesGetQuery } from '../../Common/Queries/agenciesQueries';
import {
  useApplicationsPostQuery,
  useDuplicateCheckQuery,
} from '../../Common/Queries/applicationsQueries';
import { usePositionsGetQuery } from '../../Common/Queries/positionsQueries';

import { isLogin } from '../../utils';

import { ALL_DATA_LIMIT, AuthContext, DURATION_TIME, ROLES } from '../../constants';
/**
 * @function formateData
 * @param values
 * @returns formated values
 */
export const formateData = (state, positionData) => {
  return {
    name: state.name,
    phone: `+91${state.phone}`,
    email: state.email,
    position: positionData || state.position,
    agencyId: state.agencyId,
    ...(state.agency && { agency: state.agency }),
    isUpload: state.isUpload,
    customFormData: state?.customFormData ?? [],
  };
};

/**
 * @function duplicateData
 * @param values
 * @returns duplicateData check data values
 */

export const duplicateData = (state) => {
  return {
    phone: `+91${state.phone}`,
    email: state.email,
    position: state.position,
  };
};

export function AddApplicationContainer({ setOpen, positionData, children }) {
  const { userInfo } = useContext(AuthContext);
  const role = userInfo?.roles && userInfo?.roles[0];
  // api to call from position id
  const postToApplications = useApplicationsPostQuery();

  const postDuplicateCheck = useDuplicateCheckQuery();

  const agencyList = useAgenciesGetQuery(
    { limit: ALL_DATA_LIMIT },
    {
      enabled: isLogin() && role !== ROLES.AGENCY,
      refetchInterval: DURATION_TIME,
      refetchIntervalInBackground: true,
    }
  );

  const positionList = usePositionsGetQuery(
    { limit: ALL_DATA_LIMIT },
    { enabled: isLogin(), refetchInterval: DURATION_TIME, refetchIntervalInBackground: true }
  );

  // this function
  function handleSubmitForAddApplication(finalValues, noticeValue) {
    const reqBody = formateData(finalValues, positionData, noticeValue);
    postToApplications.mutate(reqBody);
  }

  function handleDuplicateCheck(values) {
    const reqBody = duplicateData(values);
    postDuplicateCheck.mutate(reqBody);
  }

  useEffect(() => {
    if (postToApplications.isSuccess) {
      setOpen(false);
    }
  }, [postToApplications.isSuccess]);

  return Children.only(
    cloneElement(children, {
      positionData,
      postToApplications,
      handleSubmit: handleSubmitForAddApplication,
      handleDuplicateCheck,
      postDuplicateCheck,
      agencyList,
      positionList,
    })
  );
}
